var map = {
	"./assignment-completed.tsx": [
		375,
		0,
		1,
		46
	],
	"./assignment-open.tsx": [
		398,
		0,
		1,
		47
	],
	"./assignment-reopen.tsx": [
		376,
		0,
		1,
		48
	],
	"./confirm-delete.tsx": [
		377,
		0,
		5,
		1,
		49
	],
	"./create-draft.tsx": [
		378,
		0,
		1,
		50
	],
	"./edit-assignment.tsx": [
		379,
		0,
		1,
		51
	],
	"./edit-writing-frame-module.tsx": [
		396,
		0,
		1,
		52
	],
	"./error-500.tsx": [
		380,
		0,
		1,
		53
	],
	"./generic-confirm.tsx": [
		381,
		0,
		1,
		54
	],
	"./generic-delete.tsx": [
		382,
		0,
		1,
		55
	],
	"./grep-learning-goals.tsx": [
		393,
		11,
		10,
		56
	],
	"./learning-goals.tsx": [
		394,
		11,
		10,
		57
	],
	"./onboarding.tsx": [
		395,
		58
	],
	"./open-text-preview.tsx": [
		383,
		0,
		1,
		59
	],
	"./personalized-criteria-base.tsx": [
		372,
		4
	],
	"./personalized-criteria-general.tsx": [
		384,
		4,
		60
	],
	"./personalized-criteria-terms.tsx": [
		399,
		4,
		61
	],
	"./personalized-criteria-word-count.tsx": [
		400,
		4,
		62
	],
	"./personalized-tools-writing-frames.tsx": [
		401,
		4,
		64
	],
	"./personalized-tools.tsx": [
		385,
		4,
		63
	],
	"./publish-assignment.tsx": [
		386,
		0,
		1,
		65
	],
	"./publish-draft.tsx": [
		387,
		0,
		1,
		66
	],
	"./submit-review.tsx": [
		388,
		0,
		1,
		67
	],
	"./submit-text.tsx": [
		389,
		0,
		1,
		68
	],
	"./text-completed.tsx": [
		390,
		0,
		1,
		69
	],
	"./text-reopen.tsx": [
		391,
		0,
		1,
		70
	],
	"./text-review-preview.tsx": [
		392,
		0,
		1,
		71
	],
	"./user-feedback.tsx": [
		397,
		75,
		72
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 361;
module.exports = webpackAsyncContext;